<div class="container container-main">
  <div class="row">
    <div class="col-12 d-flex justify-content-start">
      <img
        src="/assets/icon-ai-assistant.svg"
        class="ai-icon me-3"
        alt="AI Assistant" />
      <div class="header">
        <h1 class="fw-700 fs-45 color-primary mb-0">AI Assistant</h1>
        <div class="color-tertiary fs-19">AI Beta Preview</div>
      </div>
    </div>
  </div>
  <app-glai></app-glai>
</div>
